import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { SpiritoryWebEndpoints } from '@/types/api/api-v2';

export default async function doRegisterSkuViewBySlug(skuSlug: string) {
  try {
    await spiritoryWebApi.post(
      `/tracking/skus/slug/${skuSlug}/track-view` as SpiritoryWebEndpoints,
      {
        timestamp: new Date().toISOString(),
      }
    );
  } catch (err) {
    throw err;
  }
}
